import io from 'socket.io-client'

function sanitizeBaseUrl(raw) {
  if (!raw) return ''
  return String(raw)
    .trim()
    .replace(/\/webreceita\/api\/v1\/?$/i, '')
    .replace(/\/realtime\/?$/i, '')
    .replace(/\/$/, '')
}

function resolveBaseUrl(explicitBaseUrl) {
  const envBase = sanitizeBaseUrl(process.env.VUE_APP_REALTIME_URL || '')
  if (envBase) return envBase

  if (explicitBaseUrl) return sanitizeBaseUrl(explicitBaseUrl)

  const apiBase = sanitizeBaseUrl(process.env.VUE_APP_API_RECEITUARIO || '')
  if (apiBase) return apiBase

  return window.location.origin
}

export function connectRealtime(params) {
  const options = params || {}
  const baseUrl = resolveBaseUrl(options.baseUrl)
  const path = String(options.path || '/socket.io')
  const companyId = options.companyId ? String(options.companyId) : ''
  const userId = options.userId ? String(options.userId) : ''

  return io(`${baseUrl}/realtime`, {
    path,
    transports: ['websocket', 'polling'],
    query: {
      companyId,
      userId,
    },
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
  })
}

